import React from 'react';
import {Link} from 'react-router';
import shield from '../assets/images/logo-small.png';
import start_left from '../assets/images/start-left.png';
import start_right from '../assets/images/start-right.png';
import logo from '../assets/images/logo.png';
import {connect} from 'react-redux';
import {getProducts} from '../actions/productActions';
import {clearChoices} from '../actions/choiceActions';
import PropTypes from 'prop-types';

class Start extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.clearChoices();
    }

    render() {
        return (
            <div id="start">
              <Link to="/" className="logo">
                <img src={shield} alt="" />
              </Link>

                <div className="text-center">
                    <div className="comp">
                        <div id="logo"><img src={logo} className="img-fluid"/></div>
                        <div className="left"><img src={start_left} className="img-fluid"/></div>
                        <div className="right"><img src={start_right} className="img-fluid"/></div>
                    </div>

                    <div className="entry-content text-center px-3 px-sm-0">
                        <div className="title d-inline-block">
                            <h1 className="text-uppercase m-0">Product Selector</h1>
                        </div>
                        <div><Link to="/surface" className="btn btn-primary btn-lg">Press Start</Link></div>
                    </div>
                    <footer className="small d-none d-md-block">© Copyright 2022 LTP. All rights reserved. Company Registration No. 2209376. VAT No. 357-2088-43</footer>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        // You can now say this.props.books
        choices: getProducts(state.choices, state.products)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearChoices: () => {
            dispatch(clearChoices());
        }
    };
};

Start.propTypes = {
    clearChoices: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(Start);



// WEBPACK FOOTER //
// ./src/components/Start.js